"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutSettingsConverter, _DataObjectConverter_);

  function SelloutSettingsConverter() {
    _classCallCheck(this, SelloutSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutSettingsConverter).apply(this, arguments));
  }

  return SelloutSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutSettingsConverter = SelloutSettingsConverter;